import { Button, Col, Dropdown, Form, Input, InputRef, Menu, Modal, PaginationProps, Row, Select, Typography, DatePicker  } from 'antd'
import { ColumnType } from 'antd/es/table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { VscPass } from 'react-icons/vsc'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { filterFunction } from '../../../common/SearchFilterComponent'
import { ICNDNApproval, ICreditNoteContext, ICreditNoteWaybills, ISearchCnDnRequest } from '../../../model/CNDNModel'
import { useCNDNStore } from '../../../stores/CNDNStore'
import { CountryEnum, DD_MM_YYYY_H_MM, DEFAULT_CURRENT, DEFAULT_PAGE_SIZE, Employee, TWO_HUNDRED_SUCCESS_CODE, UserEnum, accountListMap, dropDownMapping, isAccessible, isCNDNAccess } from '../../../utils/app-common'
import { convertDateFromMillis } from '../../../utils/luxon'
import ApprovalModalComponent from '../ApprovalModalComponent'
import BtnComponent from '../BtnComponent'
import { expandedRowRender } from '../ExpandedRowRender'
import CreditNoteCreateComponent from './CreditNoteCreateComponent'
import ConfirmationModal from './ConfirmationComponent'
import { useUserContextHook } from '../../../hooks/useUserContextHook'
import { useBookingStore } from '../../../stores/BookingStore'
import { IBookingState } from '../../../model/BookingModel'
import { useCommonStore } from '../../../stores/CommonStore'
import { ICommonState } from '../../../model/CommonModel'
import { AiOutlineClear, AiOutlineExport, AiOutlineRight, AiOutlineSearch } from 'react-icons/ai'
import PaginatedTableComponent from '../../CommonComponent/PaginatedTableComponent'
import { getUniqueId } from '../../../common/common'
import PushToOracleConfirmationModal from '../../CommonComponent/ConfirmationModal'
import dayjs, { Dayjs } from 'dayjs'

export const CreditNoteContext = React.createContext({} as ICreditNoteContext);
export const expandedRowClassName = () => 'expanded-row '

const { confirm } = Modal;

const SearchComponent = () => {
  const [form] = Form.useForm();
  const { employeeDetail } = useUserContextHook() || {};
  const GetCNDNWaybillAction = useCNDNStore(state => state?.GetCNDNWaybillAction);
  const FilterCNDNWaybillAction = useCNDNStore(state => state?.FilterCNDNWaybillAction);
  const getCustomerAction = useBookingStore(
    (state: IBookingState) => state?.GetCustomerByIdAction
  );
  const GetIndustriesGroupList = useCommonStore((state: ICommonState) => state?.GetIndustriesGroupListAction);
  const accountsList = useBookingStore((state) => state.accountList);
  const industryGroupList = useCommonStore((state: ICommonState) => state?.industryGroupList);
  const accountsListMemo = useMemo(
    () =>
      accountListMap(accountsList, "subClientId", "accountId", "accountName"),
    [accountsList]
  );
  const industryGroupListMemo = useMemo(() => dropDownMapping(industryGroupList, 'id', 'name'), [industryGroupList]);
  useEffect(() => {
    getCustomerAction(employeeDetail?.employeeId!, true);
    GetIndustriesGroupList();
  }, [employeeDetail?.employeeId, getCustomerAction]);

  const onSearchHandler = (values: ISearchCnDnRequest) => {


 let fromDate: number | undefined;
        let toDate: number | undefined;
        if (values?.dateRange) {
          fromDate = dayjs(values.dateRange[0]).startOf('day').valueOf();
          // next-day midnight so the backend's exclusive toDate includes the full day
          toDate = dayjs(values.dateRange[1]).add(1, 'day').startOf('day').valueOf();
        }

            let fromApprovalDate: number | undefined;
            let toApprovalDate: number | undefined;
            let approvalDateType: string | undefined; 
            if (values?.approvalDateRange) {
              fromApprovalDate = dayjs(values.approvalDateRange[0]).startOf('day').valueOf();
              // next-day midnight so the backend's exclusive toDate includes the full day
              toApprovalDate = dayjs(values.approvalDateRange[1]).add(1, 'day').startOf('day').valueOf();
        
              approvalDateType = 'CFO'; 
            }

    const request: ISearchCnDnRequest = {
      subClientId: values?.subClientId,
      industryGroupId: values?.industryGroupId,
      waybillNo: values?.waybillNo
    };
trackPromise(FilterCNDNWaybillAction({ directorConfirmed: true, customer: request?.subClientId, industryGroup: request?.industryGroupId, waybillNo: request?.waybillNo , fromDate,
    toDate, fromApprovalDate, toApprovalDate , approvalDateType }), "get-cn-area");  };

  const onClearHandler = () => {
    form.setFieldsValue({
      subClientId: "",
      industryGroupId: "",
      waybillNo: "",
      dateRange: undefined,
      approvalDateRange: undefined
    });
    trackPromise(GetCNDNWaybillAction({ directorConfirmed: true }), 'get-cn-area');
  };
  return (
    <Form
      form={form}
      onFinish={onSearchHandler}
      initialValues={{ subClientId: "", industryGroupId: "", waybillNo: "", dateRange: undefined, approvalDateRange: undefined   }}
      autoComplete="off"
    >
      <Row gutter={4} justify={"start"} align={"middle"}>
        <Col span={5}>
          <Form.Item
            name="subClientId"
            label="Customer Account"
            labelCol={{ span: 24 }}
          // rules={[numericValidation]}
          >
            <Select
              // disabled={disabledField?.subClientId}
              showSearch
              allowClear
              // loading={customerProgress}
              // onSelect={onDropdownHandler}
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  ?.toLocaleLowerCase()
                  ?.includes(input?.toLocaleLowerCase())
              }
            >
              {accountsListMemo?.map((customer, index) => (
                <React.Fragment key={customer?.id}>
                  <Select.Option value={customer?.id} key={customer?.id}>
                    {customer?.value}
                  </Select.Option>
                </React.Fragment>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            name="industryGroupId"
            label="Industry Group"
            labelCol={{ span: 24 }}
          >
            <Select
              // disabled={disabledField?.subClientId}
              showSearch
              allowClear
              // loading={customerProgress}
              // onSelect={onDropdownHandler}
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  ?.toLocaleLowerCase()
                  ?.includes(input?.toLocaleLowerCase())
              }
            >
              {industryGroupListMemo?.map((customer, index) => (
                <React.Fragment key={customer?.id}>
                  <Select.Option value={customer?.id} key={customer?.id}>
                    {customer?.value}
                  </Select.Option>
                </React.Fragment>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            name="waybillNo"
            label="Waybill No"
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
        </Col>


       <Col span={6}>
          <Form.Item
            name="dateRange"
            label="Created Date"
            labelCol={{ span: 24 }}
          >
            <DatePicker.RangePicker allowClear style={{ width: '100%' }} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name="approvalDateRange"
            label="Final Approval Date"
            labelCol={{ span: 24 }}
          >
            <DatePicker.RangePicker allowClear style={{ width: '100%' }} />
          </Form.Item>
        </Col>



        <Col>
          <Button
            htmlType="submit"
            icon={<AiOutlineSearch size={20} />}
            className="margin-top-1rem icon-button"
          />
        </Col>
        <Col>
          <Button
            htmlType="button"
            icon={<AiOutlineClear size={20} />}
            className="margin-top-1rem icon-button"
            onClick={onClearHandler}
          />
        </Col>
      </Row>
    </Form>
  );
};

const ExportVehicleToExcelComponent = ({
  onExportToExcelVehicleHandle,
}: {
  onExportToExcelVehicleHandle: () => void;
}) => {
  return (
    <Button
      onClick={onExportToExcelVehicleHandle}
      className="icon-button"
      icon={<AiOutlineExport size={18} />}
    >
      Export To Excel
    </Button>
  );
};

const approveOrReject = [{ id: 1, label: 'Approve' }, { id: 0, label: 'Reject' }]
export const useCreditNoteContextHook = () => {
  // get the context
  const context = React.useContext(CreditNoteContext);
  // if `undefined`, throw an error
  if (!context) {
    throw new Error("CreditNoteContext was used outside of its Provider");
  }
  return context;
};


export const MenuListComponent = ({ record, current, pageSize }: { record: ICreditNoteWaybills, current: number, pageSize: number }) => {
  const approveCreditNoteResponse = useCNDNStore(state => state?.approveCreditNoteResponse);
  const { setSelectedRow } = useCreditNoteContextHook();
  const [isApproved, setIsApproved] = React.useState(false);
  const ApproveByFinanceAction = useCNDNStore(state => state?.ApproveByFinanceAction);
  const [isConfirmationModal, setIsConfirmationModal] = useState<boolean>(false);
  const [currentRow, setCurrentRow] = useState<ICreditNoteWaybills | undefined>();
  const [isPushedToOracle, setIsPushedToOracle] = useState<boolean>();
  const RePushToOracleAction = useCNDNStore(state => state?.RePushToOracleAction);

  React.useEffect(() => {
    if (approveCreditNoteResponse === TWO_HUNDRED_SUCCESS_CODE) {
      setIsApproved(false);
      useCNDNStore.setState({ approveCreditNoteResponse: undefined })
    }

  }, [approveCreditNoteResponse])

  React.useEffect(() => {
    setIsPushedToOracle(record?.childNode?.filter(item => item?.isPushedToOracle).length > 0);
  }, [])

  const isApproveAccessible = useMemo(() =>
    isAccessible( [Employee.Sebastian_Sommer],
      [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
      isCNDNAccess()
    ),
    [isCNDNAccess]);
  const onApproveHandler = () => {
    setSelectedRow(record?.childNode);
    setIsApproved(true);
  }
  const onPushToOracleHandle = useCallback(
    (row: ICreditNoteWaybills) => {
      setCurrentRow(row);
      setIsConfirmationModal(true);
    },
    [setIsConfirmationModal, setCurrentRow]
  );

  const items = [
    ...(isApproveAccessible && record?.rejectedBy === undefined ? [{
      key: 2,
      icon: <VscPass size={18} />,
      label: 'Approve / Reject',
      onClick: onApproveHandler
    }] : []),
    // ...( !isPushedToOracle ? [{  // if pushed to orace is false then show the option
    //   key: 3,
    //   label: "Re-Push To Oracle",
    //   icon: <AiOutlineRight />,
    //   onClick: () => onPushToOracleHandle(record),
    // }] : []),
  ]
  const onSubmit = (request) => {
    trackPromise(ApproveByFinanceAction(request, current, pageSize), 'approval-area')
  }

  const onConfirmedClicked = useCallback(() => {
    trackPromise(
      RePushToOracleAction(record?.id),
      "approval-area"
    );
    setIsConfirmationModal(false);
  }, [
    record,
    RePushToOracleAction
  ]);

  return (
    <>
      <Menu
        items={items}
      />
      {isApproved ? <ApprovalModalComponent title='Division Head Approval' isOpen={isApproved} onCancel={setIsApproved} record={record?.childNode} approveOrRejectBy='isApprovedByDivisionHead' onSubmit={onSubmit} /> : null}
      {isConfirmationModal ? (
        <PushToOracleConfirmationModal
          key={getUniqueId()}
          openModal={isConfirmationModal}
          confirmClicked={() => onConfirmedClicked()}
          hideModal={() => setIsConfirmationModal(false)}
          label={` You sure you want to re-push ${record?.cndnRequestNo} to oracle ?`}
        ></PushToOracleConfirmationModal>
      ) : null}
    </>
  )
}

export default function DivisionHeadApprovalTableComponent() {

  const searchInput = React.useRef<InputRef>(null);
  const getColumnSearchProps = (dataIndex: string): ColumnType<ICreditNoteWaybills> => filterFunction(dataIndex, searchInput);

  const { promiseInProgress: getCNProgress } = usePromiseTracker({ area: 'get-cn-area' });
  const { promiseInProgress: getCreditNotePrintProgress } = usePromiseTracker({ area: 'get-cn-print-area' });
  const { promiseInProgress: approvalArea } = usePromiseTracker({ area: 'approval-area' });
  const GetCNDNWaybillAction = useCNDNStore(state => state?.GetCNDNWaybillAction);
  const waybillsState = useCNDNStore(state => state?.waybills);
  const [open, setOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(false);
  const [subClientId, setSubClientId] = React.useState<number | undefined>(undefined)
  const [selectedWaybill, setSelectedWaybill] = React.useState<string | undefined>(undefined)
  const { waybills } = waybillsState || {};
  const total = useCNDNStore(state => state?.total);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[] | number[]>([]);
  const ApproveByFinanceAction = useCNDNStore(state => state?.ApproveByDivisionHeadAction);
  const approvalResponse = useCNDNStore(state => state?.approvalResponse);

  const [current, setCurrent] = React.useState<number>(DEFAULT_CURRENT);
  const [pageSize, setPageSize] = React.useState<number>(DEFAULT_PAGE_SIZE);
  const [form] = Form.useForm();

  const ExportCnDnToExcelAction = useCNDNStore(
    (state) => state?.ExportCnDnToExcelAction
  );

  const getRecord = React.useCallback((pageNumber: number, pageSize: number) => {
    trackPromise(GetCNDNWaybillAction({ pageNumber, pageSize, directorConfirmed: true }), 'get-cn-area');
  }, [GetCNDNWaybillAction])

  React.useEffect(() => {
    getRecord(DEFAULT_CURRENT, DEFAULT_PAGE_SIZE);
  }, [getRecord])

  const columns = React.useMemo(() => [
    {
      title: 'CN/DN Request Number',
      dataIndex: 'cndnRequestNo',
      key: 'cndnRequestNo',
      width: 20,
      // ...getColumnSearchProps('cndnRequestNo')
    }, {
      title: 'Created Date',
      dataIndex: 'createdDate',
      key: 'createdDate',
      width: 20,
      // ...getColumnSearchProps('createdDate'),
      render: (createdDate: number) => convertDateFromMillis(createdDate, DD_MM_YYYY_H_MM)
    }, {
      title: 'created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
      width: 20,
      // ...getColumnSearchProps('createdBy'),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerSubAccount',
      key: 'customerSubAccount',
      width: 20,
      // ...getColumnSearchProps('customerSubAccount'),
    },
    {
      title: 'Customer Account',
      dataIndex: 'customerSubAccountCode',
      key: 'customerSubAccountCode',
      width: 20,
      // ...getColumnSearchProps('customerSubAccountCode'),
    },
    {
      title: 'Industry Group',
      dataIndex: 'industryGroup',
      key: 'industryGroup',
      width: 20,
      // ...getColumnSearchProps('industryGroup'),
    },
    {
      title: 'Director Approval By',
      dataIndex: 'approvedByDirector',
      key: 'approvedByDirector',
      width: 20,
      // ...getColumnSearchProps('approvedByDirector'),
    },
    {
      title: 'Director Approval Date',
      dataIndex: 'approvedByDirectorDate',
      key: 'approvedByDirectorDate',
      width: 20,
      // ...getColumnSearchProps('approvedByDirectorDate'),
      render: (approvedByDirectorDate: number) => convertDateFromMillis(approvedByDirectorDate, DD_MM_YYYY_H_MM)
    },
    {
      title: 'Division Head Approval By',
      dataIndex: 'approvedByDivisionHead',
      key: 'approvedByDivisionHead',
      width: 20,
      // ...getColumnSearchProps('approvedByDivisionHead'),
    },
    {
      title: 'Division Head Approval Date',
      dataIndex: 'approvedByDivisionHeadDate',
      key: 'approvedByDivisionHeadDate',
      width: 20,
      // ...getColumnSearchProps('approvedByDivisionHeadDate'),
      render: (approvedByDivisionHeadDate: number) => convertDateFromMillis(approvedByDivisionHeadDate, DD_MM_YYYY_H_MM)
    },
    {
      title: 'Finance Approval By',
      dataIndex: 'approvedByFinance',
      key: 'approvedByFinance',
      width: 20,
      // ...getColumnSearchProps('approvedByFinance'),
    },
    {
      title: 'Finance Approval Date',
      dataIndex: 'approvedByFinanceDate',
      key: 'approvedByFinanceDate',
      width: 20,
      // ...getColumnSearchProps('approvedByFinanceDate'),
      render: (approvedByFinanceDate: number) => convertDateFromMillis(approvedByFinanceDate, DD_MM_YYYY_H_MM)
    },
    {
      title: 'CFO Approval By',
      dataIndex: 'approvedByCfo',
      key: 'approvedByCfo',
      width: 20,
      // ...getColumnSearchProps('approvedByCfo'),
    },
    {
      title: 'CFO Approval Date',
      dataIndex: 'approvedByCfoDate',
      key: 'approvedByCfoDate',
      width: 20,
      // ...getColumnSearchProps('approvedByCfoDate'),
      render: (approvedByCfoDate: number) => convertDateFromMillis(approvedByCfoDate, DD_MM_YYYY_H_MM)
    },
    {
      title: 'Rejected By',
      dataIndex: 'rejectedBy',
      key: 'rejectedBy',
      width: 20,
      // ...getColumnSearchProps('rejectedBy'),
    }, {
      title: 'Remarks',
      dataIndex: 'remarks',
      key: 'remarks',
      width: 20,
      // ...getColumnSearchProps('remarks'),
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'print',
      width: 20,
      render: (record: ICreditNoteWaybills) => {
        return (
          <Dropdown.Button
            overlay={<MenuListComponent record={record} current={current} pageSize={pageSize} />}>
          </Dropdown.Button>
        )
      }
    }], [current, pageSize]);

  const onRefreshHandler = useCallback(() => {
    getRecord(DEFAULT_CURRENT, DEFAULT_PAGE_SIZE);
    setCurrent(DEFAULT_CURRENT);
    setPageSize(DEFAULT_PAGE_SIZE);
  }, [getRecord]);

  const onPaginationChange: PaginationProps['onChange'] = useCallback((current: number, pageSize: number) => {
    getRecord(current - 1, pageSize);
    setCurrent(current - 1);
    setPageSize(pageSize);
  }, [getRecord]);

  const values: any = React.useMemo(() => ({
    subClientId,
    setSelectedWaybill,
    selectedWaybill,
    setSubClientId,
    setSelectedRow,
    selectedRow
  }), [subClientId, setSelectedWaybill, selectedWaybill, selectedRow])


  useEffect(() => {
    if (approvalResponse) {
      form.resetFields();
      setSelectedRowKeys([]);
      useCNDNStore.setState({ approvalResponse })
      Modal.destroyAll()
    }
  }, [approvalResponse, form])


  const onFinishHandler = () => {
    const selectedRows = [...new Set(selectedRowKeys)];
    const request: ICNDNApproval = {
      cndnRequestIds: selectedRows,
      isApprovedByDivisionHead: Boolean(form.getFieldValue('approveOrReject')),
      remarks: form.getFieldValue('remarks')
    };
    return trackPromise(ApproveByFinanceAction(request, current, pageSize), 'approval-area')
  };
  const onSubmitHandler = () => {
    confirm({
      title: 'Confirmation',
      width: 500,
      closable: true,
      content:
        <Form form={form} onFinish={onFinishHandler} initialValues={{ approveOrReject: 1, remarks: '' }}>
          <ConfirmationModal />,
        </Form>
      ,
      okText: 'Approve / Reject',
      onOk: onFinishHandler
    })

  }
  const onSelectChange = (selectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(selectedRowKeys)
  };
  const rowSelection = {
    selectedRowKeys,
    columnTitle: '',
    columnWidth: 5,
    onChange: onSelectChange,
    fixed: 'left',
  };


  const onExportToExcelVehicleHandle = useCallback(() => {
    trackPromise(ExportCnDnToExcelAction({ directorConfirmed: true }), "download-file-area");
  }, [
    ExportCnDnToExcelAction
  ]);

  return (
    <CreditNoteContext.Provider value={values}>
      <Typography.Title level={4} >  CN\DN Division Head approval screen  </Typography.Title>
      <SearchComponent />
      <PaginatedTableComponent
        columns={columns}
        data={waybills ?? []}
        rowKey='id'
        current={current + 1}
        pageSize={pageSize}
        total={total}
        expandable={{
          expandedRowRender: (record: ICreditNoteWaybills, index, indent, expanded: boolean, fromSource: string = 'divisionHead') => expandedRowRender(record, index, indent, expanded, fromSource),
          expandedRowClassName, columnWidth: 10, columnTitle: '',
          rowExpandable: (record: ICreditNoteWaybills) => !!record?.childNode?.length
        }}
        isLoading={getCNProgress || getCreditNotePrintProgress || approvalArea}
        isRefresh
        onPaginationChange={onPaginationChange}
        onRefreshHandle={onRefreshHandler}
        rowSelected
        showRowSelection
        rowSelection={rowSelection}
        scroll={{ x: 0, y: 0 }}
        key={'id'}>
        <Row justify={'end'}>
          <BtnComponent onClickHandler={onSubmitHandler} disabled={!Boolean(selectedRowKeys.length)} label={'Approve / Reject'} ></BtnComponent>
        </Row>
        <ExportVehicleToExcelComponent
          onExportToExcelVehicleHandle={onExportToExcelVehicleHandle}
        />
      </PaginatedTableComponent>
      {open ? <CreditNoteCreateComponent open={open} onClose={(value) => setOpen(value)} /> : null}
    </CreditNoteContext.Provider>

  )
}